<template>
  <div>
    <div v-if="!isWxMini" class="mobile-tab container-ipx">
      <!-- 简历 -->
      <div
        class="item flex-column-center"
        :class="{ active: page === 'cv' }"
        @click="toModel('/cvs', 'cv')"
      >
        <img
          :src="
            page === 'cv'
              ? 'https://files.wondercv.com/icon/cv-active.png'
              : 'https://files.wondercv.com/icon/cv.png'
          "
          alt=""
        />
        <span>简历</span>
      </div>

      <!-- 课程 -->
      <!-- <div class='item flex-column-center' :class="{'active': page === 'lesson'}" @click="toModel('/lesson', 'lesson')">
        <img :src="page === 'lesson' ? 'https://files.wondercv.com/icon/curriculum2.png' :
        'https://files.wondercv.com/icon/curriculum1.png'" alt="">
        <span>课程</span>
      </div> -->

      <div
        v-if="!isHarmony"
        class="item flex-column-center"
        :class="{ active: page === 'strategy' }"
        @click="toModel('/campaign/materials?source=tab')"
      >
        <img
          :src="
            page === 'strategy'
              ? 'https://files.wondercv.com/icon/curriculum2.png'
              : 'https://files.wondercv.com/icon/curriculum1.png'
          "
          alt=""
        />
        <span>攻略</span>
      </div>

      <!-- 经验 -->
      <!-- <div class='item flex-column-center' :class="{'active': page === 'blog'}" v-if="!isBaidu && !isAlipayClient"
           @click="toModel('/community', 'blog')">
        <div class="tooltipBox" v-if="false">
          <div class="tooltip">
            {{ tooltip }}
          </div>
          <div class="triangle"></div>
        </div>
        <div v-if="messageCount > 0 && isShowMessageRedDot" :class="[messageCount > 99 ? 'message-num-max' : 'message-num']">{{messageCount > 99 ? '99+' : messageCount}}</div>
        <div v-else-if="showNowDayRedDot" class="point"></div>
        <img :src="page === 'blog' ? 'https://files.wondercv.com/rn/bbs/refresh.png' :
        'https://files.wondercv.com/icon/community.png'" alt="" ref="blogTab" class="go" :style="'transform: rotate(' + rotate + 'deg)'">
        <span>经验</span>
      </div> -->

      <!-- 求职 -->
      <div
        v-if="!isHarmony"
        class="item flex-column-center"
        :class="{ active: page === 'job' }"
        @click="toModel(logged ? '/jobs/recommend' : '/jobs/', 'job')"
      >
        <img
          :src="
            page === 'job'
              ? 'https://files.wondercv.com/icon/job-active.png'
              : 'https://files.wondercv.com/icon/job.png'
          "
          alt=""
        />
        <span>求职</span>
        <div class="point" v-if="pointShow"></div>
      </div>

      <!-- 我 -->
      <div
        class="item flex-column-center"
        :class="{ active: page === 'me' }"
        @click="
          toModel(
            isIos
              ? '/account/users/mobile_account_index'
              : '/account/users/index',
            'me'
          )
        "
      >
        <img
          :src="
            page === 'me'
              ? 'https://files.wondercv.com/icon/menu-active.png'
              : 'https://files.wondercv.com/icon/menu.png'
          "
          alt=""
        />
        <span>我</span>
      </div>
    </div>
    <update-version
      :version-show="versionShow"
      @maskClose="versionShow = false"
    />
  </div>
</template>
<script>
import { envMixin, loginMixin } from "../../assets/js/mixin/global";
import updateVersion from "../ios/update-version";
import { userMixin } from "../../assets/js/mixin/user";
import { mapActions, mapState, mapMutations } from "vuex";
import Cookies from "js-cookie";
import api from "../../api/api-list";

let moment = require("moment");

export default {
  props: {
    page: {
      type: String,
      default: "",
    },
  },
  mixins: [envMixin, loginMixin, userMixin],
  data() {
    return {
      versionShow: false,
      pointShow: false,
      showTooltip: false,
      tooltip: "如何高效地找工作?",
      rotate: 0,
      showNowDayRedDot: false,
    };
  },
  components: {
    updateVersion,
  },
  watch: {},
  computed: {
    ...mapState("jobs", ["jdList"]),
    ...mapState("community", ["messageCount", "isShowMessageRedDot"]),
    logged() {
      return Cookies.get("_t") || Cookies.get("_t_plugin");
    },
  },
  async mounted() {
    let time = window.localStorage.getItem("red-point");
    let now = new Date();
    if (
      time &&
      time === `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`
    ) {
      this.showNowDayRedDot = false;
    } else {
      window.localStorage.setItem(
        "red-point",
        `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`
      );
      this.showNowDayRedDot = true;
    }
    if (this.alreadyLogged) {
      try {
        // 获取用户信息
        await this.getUserData();
        // 如果用户的简历数大于 1
        if (this.userData.cv_count > 0) {
          this.tooltip = "会员限时免费！速来";
        } else {
          this.tooltip = "简历攻略在这里";
        }
      } catch (e) {
        console.error(e);
      }
      // try {
      //   let res = await api.users.getUserAccountInfo()
      // } catch (e) {
      //   console.error(e)
      // }
    }
    try {
      this.getUnViewCount();
    } catch (e) {
      console.error(e);
    }
    let tooltip = window.localStorage.getItem("tooltip");
    let jwt = Cookies.get("_t") || Cookies.get("_t_plugin");
    if (!tooltip && jwt) {
      this.showTooltip = true;
      setTimeout(() => {
        this.showTooltip = false;
      }, 5000);
      window.localStorage.setItem("tooltip", true);
    }
    this._showPoint();
  },
  methods: {
    ...mapActions("jobs", ["getJdJobsList"]),
    ...mapActions("community", ["getUnViewCount", "getRecommendNews"]),
    ...mapMutations("community", ["setRedDot", "setReflash"]),
    toModel(path, tab, ror) {
      // 如果当前就在信息流页面，点击之后刷新信息流数据
      let pathname = window.location.pathname;
      if (pathname === "/community" && path === "/community") {
        this.setReflash(new Date().valueOf());
        this.rotate += 360;
        // console.log(this.$refs.blogTab.style.transform, "======>tran")
      }
      try {
        if (tab !== "blog") {
          this.getUnViewCount();
        } else {
          this.showNowDayRedDot = false;
          this.setRedDot(false);
        }
      } catch (e) {}
      if (this.isWxMini) {
        let url = "";
        switch (tab) {
          case "cv":
            url = `/pages/cvIndex/cvIndex`;
            // this.$wechat.miniProgram.reLaunch({url})
            this.$router.push("/cvs");
            break;
          case "blog":
            url = `/pages/community-list/community-list?url=${process.env.VUE_APP_HOST}/community`;
            // this.$wechat.miniProgram.reLaunch({url})
            this.$router.push("/community");
            break;
          case "job":
            if (this.logged) {
              this.$router.push("/jobs/recommend");
            } else {
              window.location.href = "/jobs/";
            }
            // window.location.href = path
            break;
          case "me":
            // window.location.href = path
            this.$router.push("/account/users/index");
            break;
          case "lesson":
            // window.location.href = path
            this.$router.push("/lesson");
            break;
          default:
            this.$router.push(path);
        }
      } else if (tab !== this.page) {
        if (tab === "job") {
          this.logged
            ? this.$router.push("/jobs/recommend")
            : (window.location.href = "/jobs/");
        } else {
          this.$router.push(path);
        }
      }
    },
    async _showPoint() {
      let time = moment().format("YYYY-MM-DD");
      let showPoint = this.$db.ls.get(`recommend-point`);
      if (showPoint !== time && this.page !== "job") {
        if (!this.jdList.length) await this.getJdJobsList();
        const index = this.jdList.findIndex((v) => !v.operation);
        if (index > -1) this.pointShow = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/global/mixin";
@import "@/assets/scss/global/variable";

.mobile-tab {
  width: 100%;
  @include ipx-footer(49px, 1px);
  background: $color-light;
  position: fixed;
  bottom: 0;
  left: 0;
  border-top: 1px solid #dedfe1;
  display: flex;
  z-index: 9;
  .go {
    transition: all 0.4s;
  }
}

.mobile-tab .item {
  position: relative;
  flex: 1;

  span {
    color: #9c9c9c;
    font-size: 10px;
    font-weight: 600;
  }
}

.mobile-tab .item.active {
  color: #545564;
  font-weight: 600;
}

.mobile-tab .item img {
  height: 25px;
}

.point {
  position: absolute;
  top: 12%;
  right: 36%;
  width: 10px;
  height: 10px;
  background-color: $color-theme;
  border-radius: 50%;
  z-index: 9;
  padding: 2px;
}
.message-num {
  position: absolute;
  left: 50%;
  top: 0%;
  z-index: 9;
  background-color: $color-theme;
  width: 20px;
  height: 20px;
  border-radius: 100px;
  text-align: center;
  color: #fff;
  line-height: 20px;
  font-size: 12px;
}
.message-num-max {
  position: absolute;
  left: 50%;
  top: 0%;
  z-index: 9;
  background-color: $color-theme;
  width: 26px;
  height: 20px;
  border-radius: 100px;
  text-align: center;
  color: #fff;
  line-height: 20px;
  font-size: 12px;
}
.tooltipBox {
  width: 144px;
  height: 42px;
  position: absolute;
  top: -50px;
  animation: downUp 1s ease-out infinite;
}

@keyframes downUp {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-6px);
  }
  100% {
    transform: translateY(0px);
  }
}

.tooltip {
  width: 144px;
  height: 36px;
  border-radius: 6px;
  background-color: rgba(255, 102, 68, 1);
  color: #fff;
  text-align: center;
  line-height: 36px;
}

.triangle {
  width: 0;
  height: 0;
  border: 8px solid;
  border-color: rgba(255, 102, 68, 1) transparent transparent transparent;
  margin-left: 64px;
}
</style>
